export const PAGES = {
  AUTH_LOGIN: '/login',
  SUBSCRIPTION: '/subscription',
  SUBSCRIPTION_CANCEL: '/subscription/cancel',
  USER_CREATE: '/user/create',
  USER_UPDATE: '/user/update/:id',
  HOME_PAGE: '/',
  DASHBOARD: '/dashboard/:id',
  SENSOR_DETAILS: '/sensor-details/:id',
  ZONE_DETAILS: '/zone-details/:id',
  WELCOME: '/welcome',

  ADMIN_USERS: '/admin/users',
  ADMIN_GATEWAYS: '/admin/gateways',
  BAD_REQUEST: '/400',
  UNAUTHORIZED: '/401',
  NOT_ACCESS: '/403',
  NOT_FOUND: '/404',
  LINK_GONE: '/410',
  SERVER_ERROR: '/500',
};
